/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { Fragment, FunctionComponent, useRef } from 'react';

import { VodItemType } from 'client-code/vod-browse';

import { TIVO_SERVICES } from '../../../config';
import { VodInteractor } from '../../../core/interactors';
import { ImageType, ImageUrlGenerator } from '../../../core/utils/ImageUrlGenerator';

import './RentalImage.scss';

type RentalImageProps = {
    type?: string;
    objectId?: string;
    title?: string;
};

export const RentalTileType = {
    [VodItemType.EpisodeVodItem.toLowerCase()]: 'episode',
    [VodItemType.FolderVodItem.toLowerCase()]: 'folder',
    [VodItemType.MovieVodItem.toLowerCase()]: 'movie',
    [VodItemType.SpecialVodItem.toLowerCase()]: 'special',
    [VodItemType.UnifiedCollectionVodItem.toLowerCase()]: 'collection',
};

export const RentalTileImageType = {
    MOVIE: 'MOVIE' as ImageType,
    SPORTS: 'SPORTS' as ImageType,
    TEAM: 'TEAM' as ImageType,
    COLLECTION: 'COLLECTION' as ImageType,
};

export const RentalImage: FunctionComponent<RentalImageProps> = ({
    type,
    title,
    objectId,
}): JSX.Element => {
    const titleRef = useRef<HTMLSpanElement>(null);
    const oImageUrl = new ImageUrlGenerator();
    // TODO: Needs to access it via defined method once interactors and
    // ServiceClientImpl are aligned.
    const baseImageUrl = VodInteractor.servicesBaseUrls[TIVO_SERVICES.ImageHost];
    const tileType = type ? RentalTileType[type] : '';
    const containerTypeClass = tileType
        ? `my-rental-image-container ${tileType}`
        : 'my-rental-image-container';

    const imageType: ImageType = tileType
        ? RentalTileImageType[tileType.toUpperCase()]
        : RentalTileImageType.COLLECTION;
    const imageWidth = imageType === RentalTileImageType.MOVIE ? 252 : 662;
    const imageUrl = oImageUrl.buildImageUrl(
        baseImageUrl,
        objectId || '',
        imageType || 'COLLECTION',
        imageWidth,
        372,
    );

    const handleImageError = () => {
        if (titleRef.current) {
            titleRef.current.style.display = 'block';
        }
    };

    const renderUnrestrictedTile = () => {
        return (
            <Fragment>
                {imageUrl && <img src={imageUrl} alt="" onError={handleImageError} />}
                {title && (
                    <span style={{ display: 'none' }} ref={titleRef}>
                        {title}
                    </span>
                )}
            </Fragment>
        );
    };
    return <div className={`${containerTypeClass}`}>{renderUnrestrictedTile()}</div>;
};

export default RentalImage;
